class Orders  {
	constructor(config) {
		this.config = Object.assign({
			scope: '.myaccount'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.$scope.off('.myaccount-orders')
			.on('change.myaccount-orders', this.toggleButton.bind(this))
			.on('click.myaccount-orders', '#pay-orders', this.performPayment.bind(this));
	}

	performPayment(event) {
		event.preventDefault();
		window.showLoader();

		let orderIds = new Array();
		this.$scope.find('input[name="orders[]"]:checked').each((index, element) => orderIds.push($(element).val()));

		$.ajax({
			url: window.location.origin + window.location.pathname,
			method: 'post',
			dataType: 'json',
			success: this.handlePaymentResponse.bind(this),
			data: {
				'action': 'create_payment',
				'orders': orderIds
			}
		});
	}

	toggleButton(event) {
		if ($('input[name="orders[]"]:checked').length > 0) {
			$('#pay-orders').show();
		} else {
			$('#pay-orders').hide();
		}
	}

	handlePaymentResponse(response) {
		location.href = response.redirect;
	}
}

export default Orders;